import { render, staticRenderFns } from "./DownloadIdpDialog.vue?vue&type=template&id=068c71f2&scoped=true&"
import script from "@/components/curriculum/DownloadIdpDialog/DownloadIdpDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/curriculum/DownloadIdpDialog/DownloadIdpDialog.ts?vue&type=script&lang=ts&"
import style0 from "./DownloadIdpDialog.vue?vue&type=style&index=0&id=068c71f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c71f2",
  null
  
)

export default component.exports